<template>
  <b-row>
    <b-col cols="12">
      <question-response-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import QuestionResponseContent from './QuestionResponseContent.vue'

export default {
  components: {
    BRow,
    BCol,

    QuestionResponseContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>